import { render, staticRenderFns } from "./ceping.vue?vue&type=template&id=9b2d60c2&scoped=true"
import script from "./ceping.vue?vue&type=script&lang=ts"
export * from "./ceping.vue?vue&type=script&lang=ts"
import style0 from "./ceping.vue?vue&type=style&index=0&id=9b2d60c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2d60c2",
  null
  
)

export default component.exports